export const isVersionGreaterOrEqual = (version: string, target: string) => {
  const [v1, v2, v3] = version.split(".").map(Number)
  const [t1, t2, t3] = target.split(".").map(Number)

  if (v1 > t1) return true
  if (v1 < t1) return false

  if (v2 > t2) return true
  if (v2 < t2) return false

  if (v3 >= t3) return true

  return false
}
